export default __webpack_public_path__ + "app/images/theme-images/ic-new/icon-28@2x.webp";